import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "badge-icon" }
const _hoisted_3 = {
  key: 0,
  class: "badge-num"
}
const _hoisted_4 = { class: "header-notification-dropdown" }
const _hoisted_5 = { class: "header-notification-dropdown__header" }
const _hoisted_6 = {
  key: 0,
  class: "header-notification-dropdown__badge"
}
const _hoisted_7 = {
  key: 1,
  class: "header-notification-dropdown__empty"
}

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { notificationState } from '../../stores/notification'
import Notification from '../atoms_molecules/Notification.vue'
import { chunk } from 'lodash'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNotification',
  props: {
    colorNotiIcon: { default: '' }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const mobile = checkMobile()
const menuOpen = ref(false)

const notifications = computed(() => notificationState.notifications)
const unread = computed(() => notificationState.unread)

const topNotifications = computed(() => {
  const examNotiChunk = chunk(notifications.value, 5)
  return examNotiChunk[0] ? examNotiChunk[0] : []
})

const tab = (page: string) => {
  router.push({ name: page })
}

const onShowNotification = () => {
  notificationState.getNotification({ checkNotification: true })
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (!_unref(mobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_menu, {
          modelValue: menuOpen.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuOpen).value = $event)),
          "close-on-content-click": false
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { onClick: onShowNotification }), {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (unread.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(unread.value > 5 ? '5+' : unread.value), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_v_icon, {
                    style: _normalizeStyle({'color': __props.colorNotiIcon})
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-bell", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["style"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "#0088fc"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-bell", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "header-notification-dropdown__title" }, "お知らせ", -1 /* CACHED */)),
                (unread.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(unread.value), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_v_list, { class: "header-notification-dropdown__list" }, {
                default: _withCtx(() => [
                  (topNotifications.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(topNotifications.value, (item, index) => {
                        return (_openBlock(), _createBlock(Notification, {
                          key: index,
                          item: item,
                          mobile: true,
                          onNavigated: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = false))
                        }, null, 8 /* PROPS */, ["item"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "#d0d5dd"
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-bell-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("p", null, "通知はありません", -1 /* CACHED */))
                      ]))
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("div", {
                class: "header-notification-dropdown__footer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {menuOpen.value = false; tab(_unref(ROUTER_NAME).NOTIFICATION)})
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "すべてのお知らせを見る", -1 /* CACHED */)),
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "#0088fc"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-arrow-right", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]))
    : (_openBlock(), _createBlock(_component_v_btn, {
        key: 1,
        icon: "",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (tab(_unref(ROUTER_NAME).NOTIFICATION)), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            style: _normalizeStyle({'color': __props.colorNotiIcon})
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("mdi-bell", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["style"])
        ]),
        _: 1 /* STABLE */
      }))
}
}

})